import Vue from 'vue'

const moment = require('moment');
moment.updateLocale('en',{
    calendar: {
        lastDay: 'DD/MM/YYYY',
        sameDay: 'LT',
        nextDay : '[Tomorrow at] LT',
        lastWeek: 'DD/MM/YYYY',
        nextWeek : 'dddd [at] LT',
        sameElse: 'DD/MM/YYYY'

    }
});
moment.updateLocale('vi',{
    calendar: {
        lastDay: 'DD/MM/YYYY',
        sameDay: 'LT',
        nextDay : '[Tomorrow at] LT',
        lastWeek: 'DD/MM/YYYY',
        nextWeek : 'dddd [at] LT',
        sameElse: 'DD/MM/YYYY'
    }
});
Vue.use(require('vue-moment'),{
    moment
});
